import { TFunction } from "i18n";

interface GetImageAltTextParams {
  t: TFunction;
  description?: string;
  photographer?: string;
}

const getImageAltText = ({
  t,
  description,
  photographer,
}: GetImageAltTextParams) => {
  const altParts = [t("common:image.alt.base")];

  if (description?.trim()) {
    altParts.push(
      t("common:image.alt.description", {
        description: description.trim(),
      })
    );
  }

  if (photographer?.trim()) {
    altParts.push(
      t("common:image.alt.copywrite", {
        photographer: photographer.trim(),
      })
    );
  }

  return altParts.join(" ");
};

export default getImageAltText;
